import React from "react";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls/Card";
import CmnActionButtons from "../shared/cmnActionButtons";
import PendingCmnsTab from "../myFacilities/pendingCmnsTab";

/**
 * CMNs main tab — shows all pending CMNs system-wide (no facility/provider filter).
 * Action buttons (Download, DocuSign, Fax) operate in 'all' context.
 */
function AllPendingCmns() {
  return (
    <Card className="example example-compact">
      <CardHeader title="All Pending CMNs" />
      <CardBody>
        <CmnActionButtons contextType="all" contextId={0} />
        <PendingCmnsTab facilityId={0} physicianId={0} />
      </CardBody>
    </Card>
  );
}

export default AllPendingCmns;
